const schema = [
  {
    name: 'non_conformance_sub_type',
    displayName: 'Non Conformance Sub Type',
    systemIdField: 'id',
    displayIdField: 'id',
    path: '/non-conformance-sub-types',
    tabGroup: { key: 'system_settings', label: 'System Settings' },
    deletable: true,
    fields: [
      {
        name: 'id',
        displayName: 'ID',
        dataType: 'integer',
        required: true,
        systemIdentifier: true,
        hidden: true,
      },
      {
        name: 'name',
        displayName: 'Name',
        tooltip: 'The name or description of the non-conformance sub-type',
        dataType: 'shorttext',
        required: true,
      },
      {
        name: 'non_conformance_type_id',
        displayName: 'Category',
        tooltip: 'Select the main category to which this non-conformance sub-type belongs',
        dataType: 'reference',
        referenceType: 'select',
        referenceEntityType: 'non_conformance_type',
        required: true,
      },
    ],
  },
];
export default schema;
